import {ChangeDetectionStrategy, Component, input, output} from "@angular/core";
import {MatToolbarModule} from "@angular/material/toolbar";
import {LogoComponent} from "src/app/common/migration/shared-components/logo/logo.component";
import {SystemWarningComponent} from "../sim-system-warning/sim-system-warning.component";
import {MatSidenav} from "@angular/material/sidenav";
import {hamburguerXAnimation, slideInOutAnimation} from "./sim-header-toolbar-constants";
import {MatRippleModule} from "@angular/material/core";
import {ToolbarMenuComponent} from "@common/components/tool-bar-menu/toolbar-menu.component";

@Component({
	selector: "sim-header-toolbar",
	templateUrl: "./sim-header-toolbar.component.html",
	styleUrls: ["./sim-header-toolbar.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [slideInOutAnimation, hamburguerXAnimation],
	imports: [MatToolbarModule, LogoComponent, SystemWarningComponent, ToolbarMenuComponent, MatRippleModule],
})
export class HeaderToolbarComponent {
	// I/O
	readonly showSystemWarning = input.required<boolean>();
	readonly showBurgerMenu = input.required<boolean>();
	readonly sidenav = input.required<MatSidenav>();
	readonly nextSystemShutdown = input.required<number>();
	readonly timeUp = output();
	readonly cancelShutdown = output();
}
